import request from '@/utils/request'

export function announcementList () {
  return request({
    method: 'get',
    params: {
      do: 'announcementList'
    }
  })
}
